module.exports = __webpack_public_path__ + "../resources/images/headshot-wanda-4b88b036d61a5ee7935197c77855af5f.png";